import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email address');
      return;
    }

    setStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5ls038lhqshf1uh09tg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('Thanks for subscribing! Check your inbox for confirmation.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-orange-600 via-orange-500 to-orange-400">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mx-auto mb-6">
          <i className="ri-notification-3-line text-3xl text-white"></i>
        </div>

        <h2 className="text-5xl font-bold text-white mb-4">GET POWER TIPS</h2>
        <p className="text-xl text-white/90 mb-8">
          Weekly gear reviews, off-grid living hacks, and exclusive deals
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-xl mx-auto mb-4"
        >
          <div className="flex gap-2">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="flex-1 px-6 py-4 rounded-full bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white transition-all text-sm"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-14 h-14 flex items-center justify-center bg-black hover:bg-gray-900 text-white rounded-full transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              aria-label="Subscribe"
            >
              {status === 'loading' ? (
                <i className="ri-loader-4-line text-xl animate-spin"></i>
              ) : (
                <i className="ri-arrow-right-line text-xl"></i>
              )}
            </button>
          </div>
        </form>

        {status === 'success' && (
          <p className="text-white font-medium mb-2">{message}</p>
        )}
        {status === 'error' && (
          <p className="text-red-100 font-medium mb-2">{message}</p>
        )}

        <p className="text-sm text-white/80">No spam. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
